import { Minus, Plus } from "lucide-react";
import { cn } from "@/utils/cn";

interface ScoreStepperProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  max?: number;
}

/**
 * Controle de placar em botões -/+ (Parte 6 do escopo de integração real).
 * Substitui o antigo <input type="number"> que produzia "01" ao digitar
 * com o valor 0 já preenchido — como o valor nunca é digitado livremente,
 * esse bug de zero à esquerda deixa de existir por construção.
 */
export function ScoreStepper({ label, value, onChange, disabled, max = 20 }: ScoreStepperProps) {
  return (
    <div className="flex flex-col items-center gap-1.5">
      <span className="line-clamp-1 text-[11px] font-medium text-muted-foreground">{label}</span>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          disabled={disabled || value <= 0}
          onClick={() => onChange(Math.max(0, value - 1))}
          aria-label={`Diminuir placar de ${label}`}
          className={cn(
            "flex h-8 w-8 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors",
            "hover:bg-muted disabled:cursor-not-allowed disabled:opacity-30"
          )}
        >
          <Minus className="h-3.5 w-3.5" />
        </button>

        <span className="w-7 text-center font-display text-lg font-bold tabular-nums">{value}</span>

        <button
          type="button"
          disabled={disabled || value >= max}
          onClick={() => onChange(Math.min(max, value + 1))}
          aria-label={`Aumentar placar de ${label}`}
          className={cn(
            "flex h-8 w-8 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors",
            "hover:bg-muted disabled:cursor-not-allowed disabled:opacity-30"
          )}
        >
          <Plus className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
